function GOT_A_NEW_TASK ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const span1 = document.createElement('span')
  const span2 = document.createElement('span')
  const span3 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span1.innerHTML = 'A '
  button.innerHTML = 'task'
  span2.innerHTML = 'has been assigned to you by '
  span3.innerHTML = `${teamMember.firstName} ${teamMember.lastName}`

  span3.classList.add('font-semibold', 'text-app-color')
  button.classList.add('text-brand')

  function redirect () {
    router.push({ name: 'TaskBoard', params: { id: notification.book.id } })
  }

  button.addEventListener('click', redirect)

  p.appendChild(span1)
  p.appendChild(button)
  p.appendChild(span2)
  p.appendChild(span3)

  ref.appendChild(p)
}

function _mentionIn ({ notification, ref, router, buttonTitle, href, where }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')
  const span2 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span.innerHTML = `${teamMember.firstName} ${teamMember.lastName} `
  span1.innerHTML = 'mentioned you in the '
  button.innerHTML = buttonTitle
  span2.innerHTML = where

  span.classList.add('font-semibold', 'text-app-color')
  button.classList.add('text-brand')

  button.addEventListener('click', () => router.push(href))

  p.appendChild(span)
  p.appendChild(span1)
  p.appendChild(button)
  p.appendChild(span2)

  ref.appendChild(p)
}

function MENTIONED_IN_CHAT ({ notification, ref, router }) {
  const buttonTitle = notification.book.title
  const href = { name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link }, query: { openChat: true } }
  const where = ' chat.'

  _mentionIn({ notification, ref, router, buttonTitle, href, where })
}

function MENTIONED_IN_DISCUSSION ({ notification, ref, router }) {
  const buttonTitle = notification.discussion.title
  const href = { name: 'Discussion', params: { id: notification.book.id, team: notification.team.link, discussionId: notification.discussion.id } }
  const where = ' discussion.'

  _mentionIn({ notification, ref, router, buttonTitle, href, where })
}

function MENTIONED_IN_PAGE ({ notification, ref, router }) {
  const buttonTitle = notification.project.title
  const href = { name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link }, query: { page: notification.project.id } }
  const where = ' page.'

  _mentionIn({ notification, ref, router, buttonTitle, href, where })
}

function MENTIONED_IN_EVENT ({ notification, ref, router }) {
  const buttonTitle = notification.event.title
  const href = { name: 'WeekPlannerTeam', params: { id: notification.book.id, team: notification.team.link }, query: { spaces: notification.book.id } }
  const where = ' event.'

  _mentionIn({ notification, ref, router, buttonTitle, href, where })
}

function MENTIONED_IN_COMMENT ({ notification, ref, router }) {
  // const buttonTitle = notification.project.title
  // const href = { name: 'Discussion', params: { id: notification.book.id, team: notification.team.link, discussionId: notification.discussion.id } }
  // const where = ' page.'

  // _mentionIn({ notification, ref, router, buttonTitle, href, where })
}

function MENTIONED_IN_TASK ({ notification, ref, router }) {
  const buttonTitle = notification.task.title
  const href = { name: 'TaskBoardTeam', params: { id: notification.book.id, team: notification.team.link } }
  const where = ' task.'

  _mentionIn({ notification, ref, router, buttonTitle, href, where })
}

function ASSIGNED_TO_TASK ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')
  const span2 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span.innerHTML = `${teamMember.firstName} ${teamMember.lastName} `
  span1.innerHTML = 'assigned you to the '
  button.innerHTML = notification.task?.title
  span2.innerHTML = ' task.'

  span.classList.add('font-semibold', 'text-app-color')
  button.classList.add('text-brand')

  button.addEventListener('click', () => router.push({ name: 'TaskBoardTeam', params: { id: notification.book.id, team: notification.team.link } }))

  p.appendChild(span)
  p.appendChild(span1)
  if (notification.task?.title) { p.appendChild(button) }
  p.appendChild(span2)

  ref.appendChild(p)
}

function ADDED_TO_A_NEW_SPACE ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')
  const span2 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span.innerHTML = `${teamMember.firstName} ${teamMember.lastName} `
  span1.innerHTML = 'added you to the '
  button.innerHTML = notification.book?.title
  span2.innerHTML = ' space'

  span.classList.add('font-semibold', 'text-app-color')
  button.classList.add('text-brand')

  button.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link } }))

  p.appendChild(span)
  p.appendChild(span1)
  if (notification.book?.title) { p.appendChild(button) }
  p.appendChild(span2)

  ref.appendChild(p)
}

function A_NEW_TEAM_MEMBER ({ notification, ref }) {
  const p = document.createElement('p')
  const span = document.createElement('span')
  const span1 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span.innerHTML = `${teamMember.firstName} ${teamMember.lastName} `
  span1.innerHTML = 'joined the workspace.'

  span.classList.add('font-semibold', 'text-app-color')

  p.appendChild(span)
  p.appendChild(span1)

  ref.appendChild(p)
}

function A_SPACE_HAS_BEEN_REMOVED ({ notification, ref }) {
  ref.innerHTML = notification.message || ''
}

function A_NEW_PAGE_WAS_CREATED ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const button2 = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')
  const span2 = document.createElement('span')
  const span3 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span.innerHTML = `${teamMember.firstName} ${teamMember.lastName} `
  span1.innerHTML = 'created a new page called '
  button.innerHTML = notification.project?.title
  span2.innerHTML = ' in the '
  button2.innerHTML = notification.book?.title
  span3.innerHTML = ' space.'

  span.classList.add('font-semibold', 'text-app-color')
  button.classList.add('text-brand')
  button2.classList.add('text-brand')

  button.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link }, query: { page: notification.project.id } }))
  button2.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link } }))

  p.appendChild(span)
  p.appendChild(span1)
  p.appendChild(button)
  p.appendChild(span2)
  p.appendChild(button2)
  p.appendChild(span3)

  ref.appendChild(p)
}

function A_NEW_DISCUSSION ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const button2 = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')
  const span2 = document.createElement('span')
  const span3 = document.createElement('span')

  const teamMember = notification.teamMember.user.profile

  span.innerHTML = `${teamMember.firstName} ${teamMember.lastName} `
  span1.innerHTML = 'created a new discussion called '
  button.innerHTML = notification.discussion.title
  span2.innerHTML = ' in the '
  button2.innerHTML = notification.book.title
  span3.innerHTML = ' space.'

  span.classList.add('font-semibold', 'text-app-color')
  button.classList.add('text-brand')
  button2.classList.add('text-brand')

  button.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link }, query: { page: notification.project.id } }))
  button2.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link } }))

  p.appendChild(span)
  p.appendChild(span1)
  p.appendChild(button)
  p.appendChild(span2)
  p.appendChild(button2)
  p.appendChild(span3)

  ref.appendChild(p)
}

function NEW_CHAT_MESSAGES ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')

  span.innerHTML = 'There are unread chat messages in the '
  button.innerHTML = notification.book.title
  span1.innerHTML = ' space chat.'

  button.classList.add('text-brand')

  button.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link }, query: { openChat: true } }))

  p.appendChild(span)
  p.appendChild(button)
  p.appendChild(span1)

  ref.appendChild(p)
}

function A_SPACES_TITLE_WAS_CHANGED ({ notification, ref, router }) {
  const p = document.createElement('p')
  const button = document.createElement('button')
  const button2 = document.createElement('button')
  const span = document.createElement('span')
  const span1 = document.createElement('span')

  span.innerHTML = 'The '
  button.innerHTML = notification.oldBookTitle
  span1.innerHTML = ' space changed name to '
  button2.innerHTML = notification.book.title

  button.classList.add('text-brand')
  button2.classList.add('text-brand')

  button.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link } }))
  button2.addEventListener('click', () => router.push({ name: 'TeamBook', params: { id: notification.book.id, team: notification.team.link } }))

  p.appendChild(span)
  p.appendChild(button)
  p.appendChild(span1)
  p.appendChild(button2)

  ref.appendChild(p)
}

export default {
  // personal
  1: GOT_A_NEW_TASK,
  2: MENTIONED_IN_CHAT,
  3: MENTIONED_IN_DISCUSSION,
  4: MENTIONED_IN_PAGE,
  5: MENTIONED_IN_EVENT,
  6: MENTIONED_IN_COMMENT,
  7: ADDED_TO_A_NEW_SPACE,
  8: MENTIONED_IN_TASK,
  9: ASSIGNED_TO_TASK,
  // general
  100: A_NEW_TEAM_MEMBER,
  101: A_SPACE_HAS_BEEN_REMOVED,
  102: A_NEW_PAGE_WAS_CREATED,
  103: A_NEW_DISCUSSION,
  104: NEW_CHAT_MESSAGES,
  105: A_SPACES_TITLE_WAS_CHANGED
}
